const routes = [
  {
    path: '/cadastro/almoxarifado/tipo-item',
    name: 'itemType',
    component: () => import('@/views/cadastros/tipoItem/TipoItem.vue'),
    meta: { breadcrumb: [{ title: 'Cadastro' }, { title: 'Almoxarifado' }, { title: 'Tipo de Item' }] },
  },
  {
    path: '/cadastro/almoxarifado/tipo-item/novo',
    name: 'itemTypeNew',
    component: () => import('@/views/cadastros/tipoItem/TipoItemNew.vue'),
    meta: { breadcrumb: [{ title: 'Cadastro' }, { title: 'Almoxarifado' }, { title: 'Tipo de Item' }, { title: 'Novo' }] },
  },
  {
    path: '/cadastro/almoxarifado/tipo-item/:id/editar',
    name: 'itemTypeUpdate',
    component: () => import('@/views/cadastros/tipoItem/TipoItemNew.vue'),
    meta: { breadcrumb: [{ title: 'Cadastro' }, { title: 'Almoxarifado' }, { title: 'Tipo de Item' }, { title: 'Editar' }] },
  },
  {
    path: '/cadastro/almoxarifado/classe-item',
    name: 'itemClass',
    component: () => import('@/views/cadastros/classeItem/ClasseItem.vue'),
    meta: { breadcrumb: [{ title: 'Cadastro' }, { title: 'Almoxarifado' }, { title: 'Classe de Item' }] },
  },
  {
    path: '/cadastro/almoxarifado/classe-item/novo',
    name: 'itemClassNew',
    component: () => import('@/views/cadastros/classeItem/ClasseItemNew.vue'),
    meta: { breadcrumb: [{ title: 'Cadastro' }, { title: 'Almoxarifado' }, { title: 'Classe de Item' }, { title: 'Novo' }] },
  },
  {
    path: '/cadastro/almoxarifado/classe-item/:id/editar',
    name: 'itemClassUpdate',
    component: () => import('@/views/cadastros/classeItem/ClasseItemNew.vue'),
    meta: { breadcrumb: [{ title: 'Cadastro' }, { title: 'Almoxarifado' }, { title: 'Classe de Item' }, { title: 'Editar' }] },
  },
  {
    path: '/cadastro/almoxarifado/criterio-de-medida',
    name: 'criterionOfMeasurement',
    component: () => import('@/views/cadastros/criterioDeMedida/CriterioDeMedida.vue'),
    meta: { breadcrumb: [{ title: 'Cadastro' }, { title: 'Almoxarifado' }, { title: 'Critério de Medida' }] },
  },
  {
    path: '/cadastro/almoxarifado/criterio-de-medida/novo',
    name: 'criterionOfMeasurementNew',
    component: () => import('@/views/cadastros/criterioDeMedida/CriterioDeMedidaNew.vue'),
    meta: { breadcrumb: [{ title: 'Cadastro' }, { title: 'Almoxarifado' }, { title: 'Critério de Medida' }, { title: 'Novo' }] },
  },
  {
    path: '/cadastro/almoxarifado/criterio-de-medida/:id/editar',
    name: 'criterionOfMeasurementUpdate',
    component: () => import('@/views/cadastros/criterioDeMedida/CriterioDeMedidaNew.vue'),
    meta: { breadcrumb: [{ title: 'Cadastro' }, { title: 'Almoxarifado' }, { title: 'Critério de Medida' }, { title: 'Editar' }] },
  },
  {
    path: '/cadastro/almoxarifado/fornecedor',
    name: 'supplier',
    component: () => import('@/views/cadastros/fornecedor/Fornecedor.vue'),
    meta: { breadcrumb: [{ title: 'Cadastro' }, { title: 'Almoxarifado' }, { title: 'Fornecedor' }] },
  },
  {
    path: '/cadastro/almoxarifado/fornecedor/novo',
    name: 'supplierNew',
    component: () => import('@/views/cadastros/fornecedor/FornecedorNew.vue'),
    meta: { breadcrumb: [{ title: 'Cadastro' }, { title: 'Almoxarifado' }, { title: 'Fornecedor' }, { title: 'Novo' }] },
  },
  {
    path: '/cadastro/almoxarifado/fornecedor/:id/editar',
    name: 'supplierUpdate',
    component: () => import('@/views/cadastros/fornecedor/FornecedorNew.vue'),
    meta: { breadcrumb: [{ title: 'Cadastro' }, { title: 'Almoxarifado' }, { title: 'Fornecedor' }, { title: 'Editar' }] },
  },
  {
    path: '/almoxarifado/deposito/microLocal',
    name: 'microLocation',
    component: () => import('@/views/sistema/almoxarifado/deposito/microLocal/MicroLocal.vue'),
    meta: { breadcrumb: [{ title: 'Almoxarifado' }, { title: 'Micro Local' }] },
  },
  {
    path: '/almoxarifado/deposito/microLocal/novo',
    name: 'microLocationNew',
    component: () => import('@/views/sistema/almoxarifado/deposito/microLocal/MicroLocalNew.vue'),
    meta: { breadcrumb: [{ title: 'Almoxarifado' }, { title: 'Micro Local' }, { title: 'Novo' }] },
  },
  {
    path: '/almoxarifado/deposito/microLocal/:id/editar',
    name: 'microLocationUpdate',
    component: () => import('@/views/sistema/almoxarifado/deposito/microLocal/MicroLocalNew.vue'),
    meta: { breadcrumb: [{ title: 'Almoxarifado' }, { title: 'Micro Local' }, { title: 'Editar' }] },
  },
  {
    path: '/sistema/equipamentos',
    name: 'equipment',
    component: () => import('@/views/sistema/almoxarifado/equipamento/Equipamento.vue'),
    meta: { breadcrumb: [{ title: 'Almoxarifado' }, { title: 'Equipamento' }] },
  },
  {
    path: '/sistema/equipamento/novo',
    name: 'equipmentNew',
    component: () => import('@/views/sistema/almoxarifado/equipamento/EquipmentNew.vue'),
    meta: { breadcrumb: [{ title: 'Almoxarifado' }, { title: 'Equipamento' }, { title: 'Novo' }] },
  },
  {
    path: '/sistema/equipamento/:id/editar',
    name: 'equipmentUpdate',
    component: () => import('@/views/sistema/almoxarifado/equipamento/EquipmentNew.vue'),
    meta: { breadcrumb: [{ title: 'Almoxarifado' }, { title: 'Equipamento' }, { title: 'Editar' }] },
  },
  {
    path: '/cadastro/almoxarifado/tipo-inventario',
    name: 'inventoryType',
    component: () => import('@/views/cadastros/tipoInventario/TipoInventario.vue'),
    meta: { breadcrumb: [{ title: 'Cadastro' }, { title: 'Almoxarifado' }, { title: 'Tipos de Inventário' }] },
  },
  {
    path: '/cadastro/almoxarifado/tipo-inventario/novo',
    name: 'inventoryTypeNew',
    component: () => import('@/views/cadastros/tipoInventario/TipoInventarioNew.vue'),
    meta: { breadcrumb: [{ title: 'Cadastro' }, { title: 'Almoxarifado' }, { title: 'Tipos de Inventário' }, { title: 'Novo' }] },
  },
  {
    path: '/cadastro/almoxarifado/tipo-inventario/:id/editar',
    name: 'inventoryTypeUpdate',
    component: () => import('@/views/cadastros/tipoInventario/TipoInventarioNew.vue'),
    meta: { breadcrumb: [{ title: 'Cadastro' }, { title: 'Almoxarifado' }, { title: 'Tipos de Inventário' }, { title: 'Editar' }] },
  },
]

export default routes
